import React, { Component } from 'react';
import Search from './Search';
import Reservation from './Reservation';
import { format, addDays } from 'date-fns';
import compareAsc from 'date-fns/compareAsc';
import parseISO from 'date-fns/parseISO';
import Completed from './Completed.js';
import Failed from './Failed.js';
import * as PAGE from '../Constants/Page.js';
import TitleBar from './TitleBar'
import { Tooltip as ReactTooltip } from 'react-tooltip';

export class RatesAndAvailability extends Component {

    userData;

    constructor(props) {
        super(props);
        this.state = {
            reservation: {
                //propertyId: this.props.propertyId,
                propertyKey: this.props.propertyKey,
                PaymentKey: this.props.propertyPayment.key,
                checkIn: format(new Date(), 'yyyy-MM-dd'),
                checkOut: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
                //rooms: [],
                nights: 1,
                //adults: values.adults,
                //children: values.children,
                promoCode: '',
                selectedRooms: [],
                customerId: 0
            },

            //propertyId: this.props.propertyId,
            propertyKey: this.props.propertyKey,
            custId: 0,
            
            //selectedRooms:'',

            checkIn: new Date().toDateString(),
            checkOut: addDays(new Date(), 1).toDateString(),
            //rooms: [],
            nights: 1,
            adults: 2,
            children: 0,
            promoCode: '',        
            
            firstName: '',
            lastName: '',
            email: '',
            telephone: '',
            guestInstructions: '',
            
            loadedFromLocal: false,
            //totalPrice: 0.00,
            //payNow: 0.00,

            page: PAGE.PAGE.SEARCH,
            //page: PAGE.PAGE.SUCCESSFUL,
            message: '',
            mode: 'select',
            showDatePicker: false
        };

    }



    setSearchValues(i, o, n, r, p) {

               
        let res = { ...this.state.reservation, checkIn: format(i, 'yyyy-MM-dd'), checkOut: format(o, 'yyyy-MM-dd'), nights: n, selectedRooms: r, promoCode: p };

        

        
        this.setState({
            reservation: res,
            checkIn: i.toDateString(),
            checkOut: o.toDateString(),
            //rooms: r,
            nights: n,
            //promoCode: p,
            mode: 'select',
            showDatePicker: false

        })

        
    }

    setSelectValues(roomType, roomPrice) {

        let reservation = this.state.reservation
        
        let index = reservation.selectedRooms.findIndex((object) => object.ratePlan?.name === roomPrice.ratePlanName && object.roomType?.name === roomType.name);

        if (index > -1) return; //room already selected

        else 
        {
            index = reservation.selectedRooms.findIndex((object) => object.roomType?.name === roomType.name);  //same room type so update rateplan only

            if (index === -1) {
                index = reservation.selectedRooms.findIndex((object) => object.roomType === undefined);
            }

        }

              
        let selectedRoom = {
                        
            promotionId: roomPrice.promotionId,
            adults: roomPrice.adults,
            children: roomPrice.children,
            checkIn: roomPrice.checkIn, //needed for flattened json object BookingRoomFromJson
            nights: roomPrice.nights,
            roomTypeId: roomType.uId, //needed for flattened json object BookingRoomFromJson
            //roomTypeName: roomType.name,
            ratePlanId: roomPrice.ratePlanId, //needed for flattened json object BookingRoomFromJson
            //ratePlanName: roomPrice.ratePlanName,
            totalPrice: roomPrice.promoCodePrice,
            //imageUrl: roomType.mainImageUrl,
            firstName: '',
            lastName: '',
            notes: '',
            guestInstuctions: '',
            cancellationPolicyId: roomPrice.cancellationPolicy.id,
            depositPolicyId: roomPrice.depositPolicy.id,
            roomPrice: roomPrice,
            roomType: roomType,
            mealPlanId: roomPrice.mealPlan?.id
        };

        if (index === -1) {
            reservation.selectedRooms.push(selectedRoom);
        }
        else {
            reservation.selectedRooms[index] = selectedRoom;
        }

        //to handle multiple properties, set reservation.property values to roomtype.property values
        reservation.propertyKey = roomType.propertyKey;
        reservation.paymentKey = roomType.paymentKey

        ///*
        if (roomPrice.cancellationGracePeriod < 0 && reservation.selectedRooms.length === 1) {
            reservation.paymentKey = "pk_live_51LOdDXJ3ADxLBupp3qWb4B8oYtZ9fsU7RvfeJ6dypS106d4izqoJoJmv8ECXrpFRGE8g9LXJDUXCsq3v80dwHvtm00WNDEehae"
        }
        //*/

            
        this.updateReservation(reservation);
    }

    updateReservation(reservation) {
        reservation.totalPrice = this.getTotalPrice(reservation.selectedRooms);
        reservation.payNow = this.payNow(reservation.selectedRooms);

        

        var navToPage = reservation.selectedRooms.findIndex((object) => object.roomType === undefined) === -1 ? PAGE.PAGE.RESERVE : PAGE.PAGE.SEARCH

        this.setState({
            reservation: reservation,
            page: navToPage,
            //totalPrice: reservation.totalPrice,
            //payNow: reservation.payNow,
        })

        if (navToPage === PAGE.PAGE.RESERVE) window.scrollTo(0, 0);
    }

    payNow(selectedRooms) {

        var selected = selectedRooms.filter(room => room.roomType !== undefined)
        var total = 0;
        for (var i = 0; i < selected.length; i++) {
            for (var j = 0; j < selected[i].roomPrice.paymentSchedule.length; j++) {
                console.log('PayNow compare = ' + compareAsc(parseISO(selected[i].roomPrice.paymentSchedule[j].due), new Date()))
                console.log('Amount = ' + selected[i].roomPrice.paymentSchedule[j].amount)
                if (compareAsc(parseISO(selected[i].roomPrice.paymentSchedule[j].due), new Date()) < 1) {
                    total += selected[i].roomPrice.paymentSchedule[j].amount;
                }
            }

        }
        return total;
    }

    getTotalPrice(selectedRooms) {
        var total = 0;
        for (var i = 0; i < selectedRooms.length; i++) { total += selectedRooms[i].totalPrice; }
        return total;
    }

    setPageState(page, message) {
        this.setState({ page: page, message: message });
        
    }

    removeRoom(roomTypeName) {
        let reservation = this.state.reservation;
        //let page = undefined;
        let index = reservation.selectedRooms.findIndex((object) => object.roomType.name === roomTypeName);

        if (index >= 0 && reservation.selectedRooms.length > 1) {
            reservation.selectedRooms.splice(index, 1);
            //page = PAGE.PAGE.RESERVE;
        }
        else {
            reservation.selectedRooms[index].roomType = undefined;
            //page = PAGE.PAGE.SEARCH;
        }

        this.updateReservation(reservation);

        
    }

    changeDates() {
        let reservation = this.state.reservation;

        reservation.selectedRooms = reservation.selectedRooms.map((room) => {
            room.roomType = undefined;
            return room;
        });

        this.updateReservation(reservation);
        this.setState({showDatePicker: true})
        

        

    }

    changeRoom(roomTypeName) {
        let reservation = this.state.reservation

        let index = reservation.selectedRooms.findIndex((object) => object.roomType.name === roomTypeName);

        if (index >= 0) {
            reservation.selectedRooms[index].roomType = undefined;
        }

        this.updateReservation(reservation);

        
    }

    addRoom(adults, children) {

        var res = this.state.reservation;

        //if reservation property is not the main property alert that a new reservation must be created to add any other properties or rooms.
        if (this.state.propertyKey !== res.propertyKey) {
            alert("You have chosen a holiday apartment which is not part of our main guest house. If you wish to reserve more rooms please confirm the reservation for the apartment first and then create a new reservation for the guest house.");
        }

        var room = { adults: adults, children: children }

        res.selectedRooms.push(room);

        this.updateReservation(res);

        this.setState({
            mode: 'add',
            page: PAGE.PAGE.SEARCH

        })
    }

    changeAdults(roomTypeName, value) {
        let reservation = this.state.reservation;
        let index = reservation.selectedRooms.findIndex((object) => object.roomType.name === roomTypeName);

        reservation.selectedRooms[index].adults = value;
        //reservation.rooms[index].adults = value;
        
        this.updateReservation(reservation)
    }

    changeChildren(roomTypeName, value) {
        let reservation = this.state.reservation;
        let index = reservation.selectedRooms.findIndex((object) => object.roomType.name === roomTypeName);

        reservation.selectedRooms[index].children = value;
        //reservation.rooms[index].children = value;
        this.updateReservation(reservation)
    }

    componentDidMount() {
        document.title = "Tower House"
        //localStorage.clear();
        //this.getProperty()
        //if localStorage populate state
        this.userData = JSON.parse(localStorage.getItem('user-' + this.props.propertyKey));
        //console.log('componentDidMount: localStorage.getItem: ' + localStorage.getItem('user-' + this.propertyId))
        if (localStorage.getItem('user-' + this.props.propertyKey)) {

            let checkIn = this.userData?.checkIn ?? new Date().toDateString();
            let checkOut = this.userData?.checkOut ?? addDays(new Date(), 1).toDateString();
            let nights = parseInt(this.userData?.nights ?? '1');

            if (compareAsc(new Date(checkIn), new Date()) < 1) {
                checkIn = new Date().toDateString();
                checkOut = addDays(new Date(), 1).toDateString();
                nights = 1;
            }
            
            let res = {
                ...this.state.reservation,
                checkIn: format(new Date(checkIn), 'yyyy-MM-dd'), //string
                checkOut: format(new Date(checkOut), 'yyyy-MM-dd'), //string
                nights: nights,
                promoCode: 'LOVETOWER',//this.userData?.reservation?.promoCode ?? '',
                adults: this.userData?.reservation?.adults ?? 2,
                children: this.userData?.reservation?.children ?? 0,
                selectedRooms: this.userData?.selectedrooms ?? [{ adults: 2, children: 0 }],
                
            };

            
            this.setState({
                reservation: res,
                custId: this.userData?.custId??0,
                checkIn: checkIn,
                checkOut: checkOut,
                nights: nights,
                //adults: parseInt(this.userData.adults),
                //children: parseInt(this.userData.children),
                //promoCode: this.userData.promoCode??'',
                //roomType: this.userData.roomType,
                //ratePlan: this.userData.ratePlan,
                firstName: this.userData?.firstName,
                lastName: this.userData?.lastName,
                email: this.userData?.email,
                telephone: this.userData?.telephone,
                guestInstructions: this.userData?.guestInstructions,
                //selectedRooms: this.userData?.selectedrooms ?? [{ adults: 2, children: 0 }]
                //selectedRooms: [{ adults: 2, children: 0 }]
                //rooms: this.userData.rooms,
            })
        } else {

            let checkIn = new Date().toDateString();
            let checkOut = addDays(new Date(), 1).toDateString();

            let res = {
                ...this.state.reservation,
                checkIn: format(new Date(), 'yyyy-MM-dd'), //string
                checkOut: format(addDays(new Date(), 1), 'yyyy-MM-dd'), //string
                nights: 1,
                adults: 2,
                children: 0,
                promoCode: 'LOVETOWER',
                selectedRooms: [{ adults: 2, children: 0 }]
            };

            this.setState({
                reservation: res,
                checkIn: checkIn,
                checkOut: checkOut,
                //nights: 1,
                //adults: 2,
                //children: 0,
                //promoCode: '',
                //roomType: '',
                //ratePlan: '',
                firstName: '',
                lastName: '',
                email: '',
                telephone: '',
                guestInstructions: '',
                //rooms: [{adults:2, children:0}]
            })
        }

        this.setState({ loadedFromLocal: true });
    }
    
    componentDidUpdate() {
        console.log("componentDidUpdateCalled")
        localStorage.setItem('user-' + this.state.propertyKey, JSON.stringify(this.state));
        console.log("localStorage set " + JSON.stringify(this.state))
    }

    render() {

        return (
            <div>
                <TitleBar
                    propertyName={this.props.propertyName}
                    propertyWebsite={this.props.propertyWebsite}
                />
                
                {this.state.page===PAGE.PAGE.RESERVE && 
                    <Reservation
                    propertyPayment={this.props.propertyPayment}
                    reservation={this.state.reservation}
                    propertyKey={this.state.propertyKey}
                    close={() => this.setState({ isNewReservationState: false })}
                    roomTypes={this.props.roomTypes}
                    //checkIn={this.state.checkIn}
                    //checkOut={this.state.checkOut}
                    //nights={this.state.nights}
                    //adults={this.state.adults}
                    //children={this.state.children}
                    //promoCode={this.state.promoCode}
                    //roomType={this.state.roomType}
                    //selectedRooms={this.state.selectedRooms}
                    custId={this.state.custId}
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    email={this.state.email}
                    telephone={this.state.telephone}
                    guestInstructions={this.state.guestInstructions}
                    totalPrice={this.state.totalPrice}
                    //reserve={(values) => this.setReservation(values)}
                    reservationId={this.state.reservationId}
                    setPageState={(page, message) => this.setPageState(page, message)}
                    removeRoom={(roomTypeName) => this.removeRoom(roomTypeName)}
                    changeRoom={(roomTypeName) => this.changeRoom(roomTypeName)}
                    addRoom={(adults, children) => this.addRoom(adults, children)}
                    changeAdults={(roomTypeName, value) => this.changeAdults(roomTypeName, value)}
                    changeChildren={(roomTypeName, value) => this.changeChildren(roomTypeName, value)}
                    changeDates={() => this.changeDates()}
                    />}

                {this.state.page===PAGE.PAGE.SEARCH && this.state.loadedFromLocal &&

                    <Search
                    reservation={this.state.reservation}
                    propertyId={this.state.propertyId}
                    propertyKey={this.props.propertyKey}
                    showDatePicker={this.state.showDatePicker}
                    checkIn={this.state.checkIn}
                    checkOut={this.state.checkOut}
                    //nights={this.state.nights}
                    //adults={this.state.adults}
                    //children={this.state.children}
                    //promoCode={this.state.promoCode}
                    search={(startDate, endDate, n, r, p) => this.setSearchValues(startDate, endDate, n, r, p)}
                    select={(roomTypeId, ratePlanName) => this.setSelectValues(roomTypeId, ratePlanName)}
                    promotions={this.props.promotions}
                    //rooms={this.state.rooms}
                    roomTypes={this.props.roomTypes}
                    selectedRooms={this.state.reservation.selectedRooms}
                    mode={this.state.mode}
                    changeAdults={this.props.changeAdults}
                    changeChildren={this.props.changeChildren}
                    changeDates={() => this.changeDates()}
                    closedDates={this.props.closedDates}
                    />}



                {this.state.page===PAGE.PAGE.SUCCESSFUL && this.state.message &&

                    <Completed
                        reservation={this.state.reservation}
                        reservationId={this.state.message}
                    />

                }

                {this.state.page === PAGE.PAGE.FAIL &&

                    <Failed error={this.state.message}
                    setPageState={(page, message) => this.setPageState(page, message)}
                    />

                }

                
                
            </div>
        )
        
    }


}
